import React, { useEffect, useState } from "react";
import { Form, Select, Input,Checkbox } from "antd";
import { useSearchParams } from "react-router-dom";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { GetAllCountryApi } from '../../api/request/common.js';
import { RegisterApi } from '../../api/request/users.js';
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';

function Register() {

  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [initialValues, setInitialValues] = useState({ firstName: "", lastName: "", email: "", phoneNo: "", countryId: null, affiliateCode: (searchParams?.get('ref'))?.trim() });

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.countryName })));
      }
    } catch (error) { }
  }

  useEffect(() => {
    getContriens();
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const { data } = await RegisterApi(values);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setSearchParams('tab=login');
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoading(false);
    }
  }
  const filterOption = (input, option) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  }

  return (
    <div className="auth-page">
      <Form autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-3 gap-0 text-sm font-normal">
          <div className="py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">First Name</p>
            <Form.Item name='firstName' rules={[{ required: true, message: 'Please enter first name.' }]}>
              <Input placeholder="Enter your first name" className="border rounded-lg w-full ps-2 py-2" />
            </Form.Item>
          </div>
          <div className="py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">Last Name</p>
            <Form.Item name='lastName' rules={[{ required: true, message: 'Please enter last name.' }]}>
              <Input placeholder="Enter your last name" className="border rounded-lg w-full ps-2 py-2" />
            </Form.Item>
          </div>
          <div className="py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">Email</p>
            <Form.Item name='email' rules={[{ required: true, type: 'email', message: 'Please enter valid email.' }]}>
              <Input placeholder="Enter your email-id" className="border rounded-lg w-full ps-2 py-2" />
            </Form.Item>
          </div>
          <div className="py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">Phone No.</p>
            <Form.Item name='phoneNo' rules={[{ required: true, message: 'Please enter phone number.' }]}>
              <Input type="number" placeholder="Enter your phone no." className="border rounded-lg w-full ps-2 py-2" />
            </Form.Item>
          </div>
          <div className="w-full py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">Select Your Country</p>
            <Form.Item name="countryId" rules={[{ required: true, message: 'Please select a country.' }]}>
              <Select showSearch filterOption={filterOption} options={countries} placeholder='Select a country' />
            </Form.Item>
          </div>
          <div className="w-full py-1">
            <p className="text-[#585F70] font-semibold mb-[2px]">Referral Code</p>
            <Form.Item name="affiliateCode">
              <Input placeholder="Enter your referral code" className="border rounded-lg w-full ps-2 py-2" />
            </Form.Item>
          </div>
          
        </div>
        <div>
            <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
              <Checkbox className='mt-3'>Yes, I agreed to the <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link></Checkbox>
            </Form.Item>
          </div>
        <div className="mt-4">
          <LoadableButton type='submit' className='bg-primary text-[#FFFFFF] font-semibold text-lg rounded-lg w-full py-2 text' lable='Open Account' isLoading={isLoading} />
        </div>
         <div className="text-center text-sm mt-4">
            <p>Already have an account? <Link to="/" className="primary underline">sign in</Link></p>
        </div>
      </Form>
    </div>
  );
}
export default Register;